import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ConnectionCard = ({ connection, onMessage, onViewProfile }) => {
  return (
    <div className="bg-card rounded-lg p-4 border border-border hover:shadow-md transition-all">
      <div className="flex items-start gap-4">
        <div className="relative">
          <Image 
            src={connection?.avatar}
            alt={connection?.avatarAlt}
            className="w-16 h-16 rounded-full object-cover"
          />
          {connection?.isOnline && (
            <div className="absolute bottom-0 right-0 w-4 h-4 bg-success rounded-full border-2 border-card" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between mb-2">
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-foreground truncate">{connection?.name}</h4>
              <p className="text-sm text-muted-foreground truncate">{connection?.role}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 text-xs text-muted-foreground mb-3">
            <div className="flex items-center gap-1">
              <Icon name="Users" size={14} />
              <span>{connection?.mutualConnections} mutual</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Calendar" size={14} />
              <span>Connected {connection?.connectedSince}</span>
            </div>
          </div>
          <div className="flex gap-2">
            <Button 
              variant="outline" 
              size="xs" 
              iconName="MessageCircle"
              onClick={() => onMessage(connection?.id)}
            >
              Message
            </Button>
            <Button 
              variant="ghost" 
              size="xs"
              onClick={() => onViewProfile(connection?.id)}
            >
              View Profile
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectionCard;